import { eventNames } from 'superagent';
import * as gfunctions from './generalFunctions';

CCL.addToCart = {
  autoload: [
    ['addToCart', $('body').length > 0],
    ['addToCartFS', $('body').length > 0],
    ['cruiseAddToCart', $('.c-cruise-manager').length > 0],
    ['RestrictUser', $('body').length > 0]
  ],

  priceValue: null,
  variantQuantity: null,
  funshopcategorycode: '',

  addToCart() {
    $('body, #addToCartModal, #vibeDropdwonDynamic, .c-pdp-card, .c-product-card, .c-booking-buddy-modal, .c-tc-modal, .c-product-card-3, #upsell-product-modal, .clp-add-to-cart-modal').on('click', '.btn-add-cart', (event) => {
      this.closePreviousModal();
      this.globalAddToCart(event);
      event.stopImmediatePropagation();
    });
  },

  cruiseAddToCart() {
    $('.c-cruise-manager').on('click', '.btn-add-cart', (event) => {
      this.closePreviousModal();
      this.globalAddToCart(event);
      event.stopImmediatePropagation();
    });
  },

  addToCartFS() {
    $('body').on('click', '.fs-btn-add-cart', (event) => {
      this.closePreviousModal();
      this.FSAddToCartModal(event);
      const pageType = $('#pagetype').data('pagetype');
      if (pageType === 'CATEGORY') {
        const productPosition = Number($(event.target).data('productposition')) + 1;
        const pageNumber = Number($(event.target).data('currentpage')) + 1;
        const categoryName = $(event.target).data('sascategorycode');
        localStorage.setItem('productposition', productPosition);
        localStorage.setItem('pageNumber', pageNumber);
        localStorage.setItem('sascategorycode', categoryName);
      }
      event.stopImmediatePropagation();
    });
  },


  closePreviousModal() {
    if ($('#addToCartModal').hasClass('show')) {
      gfunctions.hideModal('addToCartModal');
    }
    if ($('#alcoholAtcModal').hasClass('show')) {
      gfunctions.hideModal('alcoholAtcModal');
    }
    if ($('#clpAddToCartModal').hasClass('show')) {
      gfunctions.hideModal('clpAddToCartModal');
    }
  },

  FSAddToCartModal(event) {
    $.ajax({
      type: 'GET',
      url: `/shop/cart/regularfs/modal/${$(event.target).data('productcode')}`
    }).done((response) => {
      this.funshopcategorycode = $(event.target).data('funshopcategorycode');
      if (response.baseProduct === false) {
        CCL.addToCart.variantsModal(response, event);
        gfunctions.hideLoader();
      } else {
        CCL.addToCart.populateNoVariantsModal(response, event);
        gfunctions.hideLoader();
      }
    }).fail(() => {
      console.log('Something went wrong');
      gfunctions.hideLoader();
    });
  },

  globalAddToCart(event) {
    /* if button has attr hasUpsell then open upsell modal */
    const productCode = $(event.target).data('productcode');
    const hasupsell = $(event.target).attr('data-hasupsell');
    /* if sailing info required is true open booking buddy modal */
    const sailingInfoNeeded = $(event.target).attr('data-sailingInfoNeeded');
    const isBrowseMode = $(event.target).attr('data-userMode');
    const isPDP = $(event.target).attr('data-isPDP');

    if (hasupsell === 'true' &&
      typeof hasupsell !== typeof undefined &&
      hasupsell !== false &&
      (sailingInfoNeeded === 'false' || typeof sailingInfoNeeded === typeof undefined)) {
      CCL.upSellProductModal.loadGlobalUpsellModal(event);
      return;
    }

    if (sailingInfoNeeded === 'true' && typeof sailingInfoNeeded !== typeof undefined && sailingInfoNeeded !== false && (isBrowseMode === 'loggedInBrowse' || isBrowseMode === 'browse')) {
      CCL.bookingBuddyObj.includeAUSailings = false;
      CCL.bookingBuddyObj.loadInitialModal(true, productCode, isPDP);
      return;
    }

    event.preventDefault();
    gfunctions.showLoader();
    const csrf = $(event.target).data('csrf') ? $(event.target).data('csrf') : $('#csrfSessionToken').data('csrf');
    const targetElement = $(event.target).data('hasvariants');
    const pageType = $('#pagetype').data('pagetype');

    const quantity = $(event.target).parents('.c-pdp-card, .modal-content').find('.quantity-input') && $(event.target).parents('.c-pdp-card, .modal-content').find('.quantity-input').val();
    const variantId = $(event.target).attr('data-variantids');
    const isSpecialService = $(event.target).attr('data-specialService');
    const bookingIdsArray = $(event.target).attr('data-bookingIds') ? $(event.target).attr('data-bookingIds').split(',') : '';
    const guestIdsArray = $(event.target).attr('data-guestIds') ? $(event.target).attr('data-guestIds').split(',') : '';
    const dataObj = {
      productCodePost: $(event.target).data('productcode'),
      CSRFToken: csrf,
      qty: quantity || 1,
      variantIds: variantId,
      bookingIds: bookingIdsArray,
      guestIds: guestIdsArray,
      specialService: isSpecialService,
      pageType
    };

    if (pageType === 'CATEGORY') {
      dataObj.productPosition = localStorage.getItem('productposition');
      dataObj.pageNumber = localStorage.getItem('pageNumber');
      dataObj.categoryName = localStorage.getItem('sascategorycode');
    }

    if (targetElement === undefined || targetElement === '') {
      $.ajax({
        type: 'POST',
        url: '/shop/cart/add',
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        data: dataObj
      }).done((response) => {
        if (response.addedToCart === true) {
          // $('.modal').modal('hide');
          gfunctions.hideModal('termsAndConditionsModal');
          gfunctions.hideModal('clpAddToCartModal');
          gfunctions.hideModal('alcoholAtcModal');
          gfunctions.hideModal('diningAtcModal');
          gfunctions.hideModal('globalUpsellProductModal');
          gfunctions.updateHeaderCartWidget(response);
          CCL.addToCart.successModal(response);
          if ($('.quantity-input')) {
            $('.quantity-input')[0].value = 1;
          }
          // make cruise cash localstorage update call
          const funshopcategorycode = $(event.target).data('funshopcategorycode');
          if ((funshopcategorycode && funshopcategorycode === 'cruise-cash') || (dataObj.categoryName && dataObj.categoryName === 'cruise-cash')) {
            gfunctions.ajaxForCruiseCashCartAmount().then(() => {
              $('.c-pdp-card .quantity-btn-wrap').find('.quantity-input').val(1);
              CCL.pdpSfPackage.pdpCruiseCashRestrication(true);
            });
          }
        }
        gfunctions.hideLoader();
      }).fail(() => {
        gfunctions.hideLoader();
        if ($('.quantity-input')) {
          $('.quantity-input')[0].value = 1;
        }
        console.log('Something went wrong');
      });
    } else {
      $.ajax({
        type: 'GET',
        url: `/shop/cart/regularfs/modal/${$(event.target).data('productcode')}`
      }).done((response) => {
        this.funshopcategorycode = $(event.target).data('funshopcategorycode');
        if (response.baseProduct === false) {
          CCL.addToCart.variantsModal(response, event);
          gfunctions.hideLoader();
        } else {
          CCL.addToCart.populateNoVariantsModal(response, event);
          gfunctions.hideLoader();
        }
      }).fail(() => {
        console.log('Something went wrong');
        gfunctions.hideLoader();
      });
    }
  },

  showCruiseCashError() {
    $('.increment-btn').attr('disabled', 'disabled');
    $('.increment-btn').addClass('disabled');
    $('.increment-btn').css('pointer-events', 'none');
    setTimeout(() => {
      $('.cc-error').remove();
      $(`<div class='cc-error' aria-live='assertive'
    role='alert' style='color:darkred; padding-top:10px;'>
      Cruise Cash limit is $500 per stateroom.
      </div>`).insertAfter('#addToCartModal .quantity-btn-wrap');
    }, 500);
  },

  hideCruiseCashError() {
    $('.cc-error').remove();
    $('.increment-btn').removeAttr('disabled');
    $('.increment-btn').removeClass('disabled');
    $('.increment-btn').css('pointer-events', 'auto');
  },

  /* eslint-disable */
  RestrictUser() {
    gfunctions.ajaxForCruiseCashCartAmount();
    $('#addToCartModal').on('click', '.increment-btn', (event) => {
      if ($(event.target).hasClass('ada-disabled')) {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
      if ($('#addToCartModal .general-add-to-cart-btn')[0].dataset.funshopcategorycode && $('#addToCartModal .general-add-to-cart-btn')[0].dataset.funshopcategorycode === 'cruise-cash') {
        const targetElement = $(event.target).parents('.quantity-btn-wrap').find('.quantity-input');
        this.variantQuantity = Number($(targetElement).val());
        let priceValue = 0;
        if ($('#addToCartModal .selectable-link.active ').length) {
          priceValue = Number($('#addToCartModal .selectable-link.active ').data('price').split('$')[1]);
        } else {
          priceValue = Number($('#addToCartModal .price').html().split('$')[1]);
        }
        let reqdQty = (500 - Number(localStorage.getItem('cruisecashcartamount'))) / priceValue;
        reqdQty = Math.floor(reqdQty);
        if (this.variantQuantity + 1 > Number(reqdQty)) {
          this.showCruiseCashError();
          $('#addToCartModal .btn-add-cart').attr('disabled', 'disabled');
        } else if (this.variantQuantity + 1 === Number(reqdQty)) {
          this.showCruiseCashError();
        } else {
          this.hideCruiseCashError();
        }
      }
    });
    // When user clicks on decrement button enable increment button
    $('#addToCartModal').on('click', '.decrement-btn', (event) => {
      this.hideCruiseCashError();
    });
  },
  /* eslint-enable */

  variantsModal(res, clickEvent) {
    let variants = '';
    let noItems = '';
    const data = (res.funshopVariantList && res.funshopVariantList !== null) ? res.funshopVariantList : res;

    $('#addToCartModal .btn-add-cart').attr('data-funshopcategorycode', this.funshopcategorycode);
    $('#addToCartModal .modal-body .cart-card-body .selectable-wrap').html('');
    CCL.addToCart.changeVariants(data[0].productCode, data[0].productName, data[0].variantCategoryName, data[0].price, data[0].imageUrl, data[0].strikeOutPrice, data[0].promotionResultsData, clickEvent);

    if (data[0].hasUpsell) {
      $('#addToCartModal .modal-footer .btn-red').attr('data-hasupsell', 'true');
    }
    $.each(data, (index, item) => {
      const hasupsellAttr = item.hasUpsell ? 'data-hasupsell="true"' : '';
      variants += `<a class="selectable-link" href="#" data-productcode="${item.productCode}" data-productname="${item.productName}" data-variantcategoryname="${item.variantCategoryName}" data-rootcategoryname="${item.rootCategoryName}" data-strikeoutprice="${item.strikeOutPrice}" data-price="${item.price}" data-imageurl="${item.imageUrl}" data-promotionresultsdata='${item.promotionResultsData}' ${hasupsellAttr}>${item.categoryName}</a>`;
      noItems = index;
    });
    $('#addToCartModal .modal-body .cart-card-body .selectable-wrap').append(variants);
    $('#addToCartModal .modal-body .cart-card-body .selectable-wrap a:first').addClass('active');
    $('#addToCartModal .modal-body .cart-card-body .quantity-btn-wrap input').val(1);
    // $('.decrement-btn').addClass('disabled');
    // $('.decrement-btn').attr('disabled', 'disabled');
    // $('.increment-btn').removeAttr('disabled');
    // $('.increment-btn').removeClass('disabled');
    // $('.increment-btn').css('pointer-events', 'auto');
    // $('.cc-error').remove();
    const firstVar = $('#addToCartModal .modal-body .cart-card-body .selectable-wrap a:first').data('variantcategoryname');
    const priceValue = $('#addToCartModal .modal-body .cart-card-body .selectable-wrap a:first')[0].innerHTML;
    $('#addToCartModal .modal-body .cart-card-body .xyz').remove();
    $('#addToCartModal .modal-body .cart-card-body .sub-title').before(`<div class="sr-only xyz" tabindex="0">select ${firstVar} group with ${noItems + 1} items</div>`);
    $('#addToCartModal .modal-body .cart-card-body .selectable-wrap a:first').attr('aria-label', `selected ${priceValue}`);
    $('#addToCartModal').modal();

    $('#addToCartModal').on('click', '.selectable-link', (event) => {
      event.preventDefault();
      const targetElement = $(event.target).parents('.modal-body').find('.quantity-input');
      $(targetElement).val(1);
      $('.c-add-to-cart-modal .decrement-btn').addClass('disabled');
      $('.c-add-to-cart-modal .decrement-btn').attr('disabled', 'disabled');
      this.hideCruiseCashError();
      $('#addToCartModal .modal-footer .btn-red').removeAttr('data-hasupsell');
      $('#addToCartModal .modal-body .cart-card-body .selectable-wrap a').removeClass('active');
      $(event.target).addClass('active');
      const variantcategoryname = $(event.target).data('variantcategoryname');
      const priceVal = $(event.target)[0].innerHTML;
      $('.selectable-link').removeAttr('aria-label');
      $('.selectable-wrap a').each((i, e) => {
        const price = e.innerText;
        $(e).attr('aria-label', price);
      });
      $(event.target).attr('aria-label', `selected ${priceVal}`);
      $('#addToCartModal .modal-footer .btn-red').data('productcode', $(event.target).data('productcode'));
      if (event.target.dataset.hasupsell === 'true') {
        $('#addToCartModal .modal-footer .btn-red')[0].dataset.hasupsell = 'true';
      }
      const tempPromoData = data.filter(x => x.productCode === $(event.target).data('productcode'));
      const promoData = tempPromoData.length ? tempPromoData[0].promotionResultsData : null;
      CCL.addToCart.changeVariants($(event.target).data('productcode'), $(event.target).data('productname'), $(event.target).data('variantcategoryname'), $(event.target).data('price'), $(event.target).data('imageurl'), $(event.target).data('strikeoutprice'), promoData, clickEvent);
    });
    $('.keepShopingLink').attr('href', res.redirectUrl);
  },
  populateNoVariantsModal(res, clickEvent) {
    const data = res.baseProductInfo;
    $('#addToCartModal .btn-add-cart').attr('data-funshopcategorycode', this.funshopcategorycode);
    $('.decrement-btn').addClass('disabled');
    $('.decrement-btn').attr('disabled', 'disabled');
    $('.increment-btn').removeAttr('disabled');
    $('.increment-btn').removeClass('disabled');
    $('.increment-btn').css('pointer-events', 'auto');
    $('.cc-error').remove();
    $('#addToCartModal .modal-body .cart-card-body .quantity-btn-wrap input').val(1);
    $('#addToCartModal .modal-body .cart-card-body .selectable-wrap').html('');
    $('#addToCartModal .modal-body .cart-card-image').attr('aria-label', `${data.productName} image`);
    if ($('#cloudMediaConversionFlag').data('cloudmediaconversionflag') === true) {
      $('#addToCartModal .modal-body .cart-card-image img').attr('src', `${data.imageUrl}?w=142&h=86`);
    } else {
      $('#addToCartModal .modal-body .cart-card-image img').attr('src', `${data.imageUrl}&w=142&h=86`);
    }
    $('#addToCartModal .modal-body .cart-card-body .title').text(data.productName);
    if (data.strikeOutPrice) {
      $('#addToCartModal .modal-body .cart-card-body .price').html(`
      <div class="strikeout-text greytext" aria-label="Before the price was ${data.strikeOutPrice}" role="textbox">
        ${data.strikeOutPrice}
      </div>
      <div aria-label="Current price is ${data.price}" role="textbox">
        ${data.price}
      </div>
      `);
    } else {
      $('#addToCartModal .modal-body .cart-card-body .price').text(`${data.price}`).attr('aria-label', `Price is ${data.price}`);
    }
    $('.promo-texts').remove();
    let tempHtmlCode = '';
    if (data.promotionResultsData !== '' && data.promotionResultsData !== null) {
      data.promotionResultsData.forEach(element => {
        tempHtmlCode += `<div class="best-seller general-best-seller" role="textbox" aria-label="${element.description}"
                style="background-color: #10559a">
                <span class="info-icon" aria-hidden="true">
                  <img src="/_ui/responsive/ccl/assets/icons/star_white.svg" alt="${element.description}" width="11"
                    height="12">
                </span>
                ${element.description}
              </div>`;
      });
    }

    $(`<div class="promo-texts">${tempHtmlCode}</div>`).insertAfter($('#addToCartModal .modal-body .cart-card-body .title'));

    $('#addToCartModal .modal-footer .btn-red').data('productcode', data.productCode);
    if (data.hasUpsell) {
      $('#addToCartModal .modal-footer .btn-red')[0].dataset.hasupsell = 'true';
    } else {
      $('#addToCartModal .modal-footer .btn-red')[0].dataset.hasupsell = 'false';
      $('#addToCartModal .modal-footer .btn-red').removeAttr('data-hasupsell');
    }
    $('#addToCartModal .modal-body .sub-title').hide();
    $('#addToCartModal').modal();

    $('#addToCartModal .btn-add-cart').attr('aria-label', `Add ${data.productName} to the cart with price ${data.price}`);

    $('.keepShopingLink').attr('href', res.redirectUrl);

    if (clickEvent.target.dataset.funshopcategorycode && clickEvent.target.dataset.funshopcategorycode === 'cruise-cash') {
      this.checkCruiseCashCondition(data.price);
    }
  },

  checkCruiseCashCondition(price) {
    $('#addToCartModal .btn-add-cart').removeAttr('disabled');
    const cruiseCashAmt = Number(price.split('$')[1].trim()) + Number(localStorage.getItem('cruisecashcartamount'));
    const cruiseCashAmtIntoTwo = (Number(price.split('$')[1].trim()) * 2) + Number(localStorage.getItem('cruisecashcartamount'));

    if (cruiseCashAmt > 500) {
      setTimeout(() => {
        this.showCruiseCashError();
        $('#addToCartModal .btn-add-cart').attr('disabled', 'disabled');
      }, 500);
    } else if (cruiseCashAmt === 500) {
      setTimeout(() => {
        this.showCruiseCashError();
      }, 500);
    } else {
      this.hideCruiseCashError();
    }

    if (cruiseCashAmtIntoTwo > 500) {
      console.log('going inside');
      CCL.addToCart.showCruiseCashError();
    }
  },

  changeVariants(productCode, productName, variantCategoryName, price, imageUrl, strikeOutPrice = null, promotionResultsData = null, clickEvent = null) {
    if (clickEvent.target.dataset.funshopcategorycode && clickEvent.target.dataset.funshopcategorycode === 'cruise-cash') {
      this.checkCruiseCashCondition(price);
    }
    $('#addToCartModal .modal-body .cart-card-image').attr('aria-label', `${productName} image`);
    if ($('#cloudMediaConversionFlag').data('cloudmediaconversionflag') === true) {
      $('#addToCartModal .modal-body .cart-card-image img').attr('src', `${imageUrl}?w=142&h=86`);
    } else {
      $('#addToCartModal .modal-body .cart-card-image img').attr('src', `${imageUrl}&w=142&h=86`);
    }
    $('#addToCartModal .modal-body .cart-card-body .title').text(productName);
    if (promotionResultsData !== '' && promotionResultsData !== null) {
      $('.promo-texts').remove();
      let tempHtmlCode = '';
      promotionResultsData.forEach(element => {
        tempHtmlCode += `<div class="best-seller general-best-seller" role="textbox" aria-label="${element.description}"
                style="background-color: #10559a">
                <span class="info-icon" aria-hidden="true">
                  <img src="/_ui/responsive/ccl/assets/icons/star_white.svg" alt="${element.description}" width="11"
                    height="12">
                </span>
                ${element.description}
              </div>`;
      });

      $(`<div class="promo-texts">${tempHtmlCode}</div>`).insertAfter($('#addToCartModal .modal-body .cart-card-body .title'));
    }
    $('#addToCartModal .modal-body .cart-card-body .sub-title').text(`Select ${variantCategoryName}`);
    if (strikeOutPrice) {
      $('#addToCartModal .modal-body .cart-card-body .price').html(`
      <div class="strikeout-text greytext" aria-label="Before the price was ${strikeOutPrice}" role="textbox">
        ${strikeOutPrice}
      </div>
      <div aria-label="Current price is ${price}" role="textbox">
        ${price}
      </div>
      `);
    } else {
      $('#addToCartModal .modal-body .cart-card-body .price').text(`${price}`).attr('aria-label', `Price is ${price}`);
    }
    $('#addToCartModal .modal-footer .btn-red').data('productcode', productCode);
    $('#addToCartModal .btn-add-cart').attr('aria-label', `Add ${productName} to the cart with price ${price}`);
  },
  successModal: function successModal(data) {
    $('.modal').modal('hide');
    // SAS Event for add to cart
    if (data && data.cclSasAnalyticsJsonData) {
      gfunctions.sasEvents('send', data.cclSasAnalyticsJsonData);
    }

    // if this is FBT Add to Cart response
    if (data.cartModification && data.cartModification.cartModificationDetails && data.cartModification.cartModificationDetails.length) {
      const addedProducts = data.cartModification.cartModificationDetails.filter(x => x.quantityAdded > 0);
      if (addedProducts.length) {
        // unselect selected and select unselected
        $('.fbt-product-names-section .product-name input').trigger('click');

        const modalBodyStart = '<div class="fbt-cart-sucess">';
        const modalBodyEnd = '</div>';
        let modalBody = '';
        $.each(addedProducts, (index, value) => {
          // Remove product from list
          // $(`#productCheck-${value.product.code}`).trigger('click');
          if ($(`#productImg-${value.product.code}`).length && $(`#productImg-${value.product.code}`).parent()[0] && $(`#productImg-${value.product.code}`).parent()[0].previousElementSibling) {
            $(`#productImg-${value.product.code}`).parent()[0].previousElementSibling.remove();
          }
          $(`#productImg-${value.product.code}`).parent().remove();
          $(`#productName-${value.product.code}`).remove();
          let prodCode = value.product.code;
          if (value.product.category && value.product.category === 'shoreex') {
            prodCode = value.product.shoreExData.skuCode;
          }

          let imgSrc = value.product.imageUrl ? value.product.imageUrl : value.product.images[0].url;
          if ($('#cloudMediaConversionFlag').data('cloudmediaconversionflag') === true) {
            imgSrc = `${imgSrc}?w=95&h=57`;
          } else {
            imgSrc = `${imgSrc}&w=95&h=57`;
          }
          modalBody += `<div class="row mb-4">
                          <div class="col-md-2" aria-label="" role="textbox">
                            <img class="fbt-product-img" src="${imgSrc}" alt="${value.product.name}">
                          </div>
                          <div class="col-md-10 d-flex flex-column justify-content-center">
                            <div class="title">${value.product.name}</div>
                          </div>
                        </div>`;
        });

        if ($('.plus-icon:first-child').previousElementSibling === null || $('.plus-icon:first-child').previousElementSibling === undefined) {
          $('.plus-icon:first-child').remove();
        }

        // Hide FBT component if products are less than 2 after ATC
        if ($('.fbt-product-names-section .product-name').length < 2) {
          $('#fbtComponent').hide();
        }

        $('#addToCartSuccessModal .modal-body').hide();
        $('#addToCartSuccessModal .fbt-modal-body').empty().html(`${modalBodyStart} ${modalBody} ${modalBodyEnd}`).show();
        $('.keepShopingLink').attr('data-dismiss', '');
        $('#addToCartSuccessModal').modal();
      }
    } else {
      let name = '';
      if (data.productCard.productType === 'SF' || data.productCard.productType === 'DI' || data.productCard.productName) {
        name = data.productCard.productName;
      } else {
        name = data.productName;
      }
      $('#addToCartModal .modal-body .cart-card-image').attr('aria-label', `${name} image`);
      // if ($('#cloudMediaConversionFlag').data('cloudmediaconversionflag') === true) {
      //   if (data.imageRealFileName) {
      //     $('#addToCartSuccessModal .modal-body .cart-card-image img').attr('src', `${data.imageRealFileName}`);
      //   } else {
      //     $('#addToCartSuccessModal .modal-body .cart-card-image img').attr('src', `/shop/media/image/${data.productCard.productId}/${name}.jpeg?w=95&h=57`);
      //   }
      // } else {
      $('#addToCartSuccessModal .modal-body .cart-card-image img').attr('src', `${data.productCard.imageUrl}&w=95&h=57`);
      // }

      $('#addToCartSuccessModal .modal-body .cart-card-body .title').text(name);
      if (data.productCard.productType === 'SF' || data.productCard.productType === 'DI') {
        $('#addToCartSuccessModal .modal-body .cart-card-body .title').text(name);
      }
      if (!data.qtyAdded) {
        $('#addToCartSuccessModal .modal-body .cart-card-body .quantity').hide();
      }
      $('#addToCartSuccessModal .modal-body .cart-card-body .qtyAdded').text(data.qtyAdded);

      $('.keepShopingLink').attr('href', data.redirectUrl);
      $('#addToCartSuccessModal .fbt-modal-body').empty().hide();
      $('#addToCartSuccessModal .modal-body').show();
      $('#addToCartSuccessModal').modal();
      // If user is on CMP page - dont reload page, just close the modal
      if (window.location.toString().includes('booked/home')) {
        /* eslint-disable */
        $('.keepShopingLink').attr('href', 'javascript:void(0)');
        /* eslint-enable */
        $('.keepShopingLink').attr('data-dismiss', 'modal');
      }

      // If its favorite page
      if ($('body').find('#wishlistpage').length && ($('body').find('#wishlistpage')[0].dataset.wishlistpage === true || $('body').find('#wishlistpage')[0].dataset.wishlistpage === 'true')) {
        this.favPagePostAddToCart(data);
      }
    }
  },

  favPagePostAddToCart(response) {
    $('body').find(`.favorite-card-${response.productCard.productId} .in-cart-pill`).removeClass('d-none');
    $('body').find(`.favorite-card-${response.productCard.productId} .btn-red`).text('Add To Cart Again');
  }


};



// WEBPACK FOOTER //
// ./src/js/add-to-cart.js